import angular from 'angular'

import templateUrl from './wage-policy-list.component.html'
import { WagePolicyHistoryModal } from './wage-policy-history-modal.component';

export const WagePolicyListComponent = {
    controller: WagePolicyListController,
    controllerAs: "vm",
    templateUrl
};

export function WagePolicyListController($uibModal, utilityService, wagePolicyService) {
    'ngInject'
    const vm = this;
    vm.$onInit = $onInit;
    vm.pageSize = 15;
    vm.pageNumber = 1;
    vm.wagePolicies;
    vm.filters = {};

    vm.showEditPage = showEditPage;
    vm.showNewPage = showNewPage;
    vm.filterWagePolicies = filterWagePolicies;
    vm.filterWagePolicy = filterWagePolicy;

    function $onInit() {
        utilityService.showLoading();
        wagePolicyService.retrieveWagePolicies()
            .then(function (wagePolicies) {
                vm.wagePolicies = wagePolicies;
            })
            .catch(function (ex) {
                console.log("Initial load failed: " + (ex.statusText || (ex.message !== "" ? ex.message : ex)));
            })
            .then(function () {
                utilityService.hideLoading();
            });
    }

    function showEditPage(policy) {
        return $uibModal.open({
            ...WagePolicyHistoryModal,
            resolve: {
                policy: () => policy
            }
        })
            .result.then(function (updatedPolicy) {
                angular.extend(policy, updatedPolicy);
                return policy;
            });
    }

    function showNewPage() {
        showEditPage({})
            .then(function (policy) {
                // Add policy to the top of the list.
                vm.wagePolicies.unshift(policy);
            });
    }

    function filterWagePolicies(policies) {
        return policies && policies.filter(filterWagePolicy);
    }

    function filterWagePolicy(policy) {
        return containsInvariant(policy.StateName, vm.filters.StateName)
            && ((vm.filters.NoCity || containsInvariant(policy.City, vm.filters.City))
                && (!vm.filters.NoCity || !policy.City))
            && containsInvariant(policy.CountryName, vm.filters.CountryName);
    }

    function containsInvariant(wholeString, instance) {
        return !instance || instance === "*" && (wholeString || "") === "" || (wholeString || "").toLowerCase().indexOf((instance || "").toLowerCase()) > -1;
    }
}
